// A cart the backend can no longer price because a Foodango product left the
// diet's offer (withdrawn, deactivated, excluded for the catering). Since
// MPL-3829 the pricing answers 422 `product_items_not_priced` (and the write
// validation `product_not_available`) with the `productId` to drop — on PUT,
// but also on GET /cart, merge, discount code, order and payment creation, so
// the cart stays unreadable until the client removes that entry.
const UNAVAILABLE_PRODUCT_CODES: readonly string[] = [
  "product_items_not_priced",
  "product_not_available",
];

const readProductId = (error: object): string | null => {
  const code =
    "error" in error && typeof error.error === "string" ? error.error : null;
  if (code === null || !UNAVAILABLE_PRODUCT_CODES.includes(code)) {
    return null;
  }

  return "productId" in error && typeof error.productId === "string"
    ? error.productId
    : null;
};

// The offending product id, or null for any other failure. Understands the raw
// rejection of `lib/methods` (`{ status, error, productId }`), an `ApiError`
// carrying the forwarded body in `data`, and errors wrapped in `cause`.
export const getUnavailableProductId = (error: unknown): string | null => {
  if (typeof error !== "object" || error === null) {
    return null;
  }

  const direct = readProductId(error);
  if (direct) {
    return direct;
  }

  if ("data" in error && typeof error.data === "object" && error.data) {
    const fromData = readProductId(error.data);
    if (fromData) {
      return fromData;
    }
  }

  if ("cause" in error) {
    return getUnavailableProductId(error.cause);
  }

  return null;
};

export const isUnavailableProductError = (error: unknown): boolean =>
  getUnavailableProductId(error) !== null;
